import { QueryClient } from '@tanstack/react-query';

import { DEFAULT_RETRY, DEFAULT_RETRY_BACKOFF } from './config';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Queries will retry DEFAULT_RETRY times by default if they fail
      retry: DEFAULT_RETRY,
      // Using exponential backoff for retries
      retryDelay: DEFAULT_RETRY_BACKOFF,
      // Queries will never become stale and will not trigger a refetch until manually invalidated
      staleTime: Infinity,
      // Prefer cached data over network data (offlineFirst) for Web / PWA
      networkMode: 'offlineFirst',
      // Queries will refetch on window focus
      refetchOnWindowFocus: true,
      // Enable background refetching
      refetchOnReconnect: 'always',
    },
  },
});
